import React, { useState, useEffect, useRef } from "react"
import { Box, TextField } from "@mui/material"

export const CustomInputField = ({ value, onChange, placeholder, isColorInput = false, colorValue = "" }) => {
    const [localValue, setLocalValue] = useState(value || "");
    const debounceTimeout = useRef(null);

    // Sync local state with prop only if it's vastly different or initially
    // Check if the incoming value is different from what we expect to prevent cursor jumps if possible, 
    // though simpler sync is usually sufficient for color/simple text.
    useEffect(() => {
        setLocalValue(value || "");
    }, [value]);

    const handleChange = (newValue) => {
        setLocalValue(newValue);

        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            onChange(newValue);
        }, 100); // 100ms debounce
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                width: 296,
                height: 40,
                borderRadius: "8px",
                border: "1px solid #D5DCE1",
                backgroundColor: "#FFF",
                boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
                pl: 1.5,
                gap: 1.5,
            }}
        >
            {isColorInput && (
                <Box
                    sx={{
                        width: 16,
                        height: 16,
                        borderRadius: "50%",
                        backgroundColor: localValue, // Use localValue for instant feedback
                        cursor: "pointer",
                        flexShrink: 0,
                        fontFamily: "Inter",
                        position: "relative",
                        overflow: "hidden"
                    }}
                >
                    <input
                        type="color"
                        value={localValue || "#000000"} // Ensure fallback for color input
                        onChange={(e) => handleChange(e.target.value)}
                        style={{
                            position: "absolute",
                            top: -2,
                            left: -2,
                            width: 30,
                            height: 30,
                            opacity: 0,
                            cursor: "pointer",
                            padding: 0,
                            margin: 0,
                            border: "none"
                        }}
                    />
                </Box>
            )}
            <TextField
                type="text"
                value={localValue}
                onChange={(e) => handleChange(e.target.value)}
                placeholder={placeholder}
                variant="standard"
                size="small"
                autoComplete="off"
                InputProps={{
                    disableUnderline: true,
                }}
                inputProps={{
                    style: {
                        fontSize: "14px",
                        color: "#556575",
                        fontFamily: "Inter",
                        padding: 0,
                    },
                }}
                sx={{
                    flex: 1,
                    fontFamily: "Inter",
                    width: "100%",
                    paddingBottom: '1px',
                    "& .MuiInput-underline:before": { borderBottom: "none !important" },
                    "& .MuiInput-underline:hover:before": { borderBottom: "none !important" },
                    "& .MuiInput-underline:after": { borderBottom: "none !important" },
                    "& .MuiInput-underline.Mui-focused:after": { borderBottom: "none !important" },
                    "& .MuiInputBase-input": {
                        fontSize: "14px !important",
                        color: "#556575",
                        fontFamily: "Inter",
                        height: "24px",
                        "&::placeholder": {
                            color: "#A0AABB",
                            opacity: 1,
                            fontSize: "14px",
                        },
                    },
                }}
            />
        </Box>
    )
}
